import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { environment } from "../environments/environment.development";

@Injectable({ providedIn: "root" })
export class LoggingService {
  private http = inject(HttpClient);
  private baseUrl = environment.apiBaseUrl;
  logClientError(payload: any): Observable<any> {
    try {
      return this.http.post(`${this.baseUrl}logs/client`, payload);
    } catch {
      return of(null);
    }
  }
}
